<template>
    <div>
        <div class="az-form-content">
            <p v-if="itensELotes.lotes.length === 0 && itensELotes.itens.length === 0"
               class="mensagem-quando-vazio">
                Não há itens para esta compra direta.
            </p>

            <div v-else>
                <painel-lote-edicao v-if="itensELotes.lotes.length > 0"
                                    v-model="itensELotes.lotes"
                                    :possuiValorReferencia="resumoCompraDireta.possuiValorReferencia"
                                    :casasDecimais="itensELotes.casaDecimal"
                                    :casasDecimaisQuantidade="itensELotes.casasDecimaisQuantidade"
                                    :criterioJulgamento="resumoCompraDireta.criterioJulgamento"
                                    :prefixoValor="resumoCompraDireta.prefixoValor"
                                    :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                                    @excluirLote="exibirDialogoExclusao"
                                    @alteracaoExclusividadeLote="tratarAlteracaoExclusividadeLote"/>

                <painel-item-edicao v-if="itensELotes.itens.length > 0"
                                    v-model="itensELotes.itens"
                                    :possuiValorReferencia="resumoCompraDireta.possuiValorReferencia"
                                    :casasDecimais="itensELotes.casaDecimal"
                                    :casasDecimaisQuantidade="itensELotes.casasDecimaisQuantidade"
                                    :criterioJulgamento="resumoCompraDireta.criterioJulgamento"
                                    :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                                    :prefixoValor="resumoCompraDireta.prefixoValor"
                                    @excluirItemSemLote="exibirDialogoExclusao"
                                    @alteracaoExclusividadeItem="tratarAlteracaoExclusividadeItem"/>

                <div v-if="resumoCompraDireta.possuiValorReferencia && !isCriterioJulgamentoMaiorDesconto && (itensELotes.itens.length > 0 && itensELotes.lotes.length > 0)"
                     id="totalGeralCompraDireta"
                     class="total ma-0">
                    <p>
                        <strong>Total Geral: </strong> {{ totalGeral | cdCurrency(prefix, itensELotes.casaDecimal)}}{{suffix}}
                    </p>
                </div>
            </div>
        </div>

        <div class="az-actions-form ajuste-acoes">
            <botao-voltar @voltar="tratarEventoVoltar"/>
            <botao-salvar @salvar="tratarEventoSalvar"/>
            <botao-salvar-avancar @salvarEAvancar="tratarEventoSalvarEAvancar"/>
        </div>

        <mensagem-confirmacao :exibirMensagem="visibilidadeDialogoExclusao"
                              @confirmado="tratarEventoExcluirConfirmado"
                              @recusado="fecharDialogo"/>

        <alert :exibir.sync="exibirListaErros"
               :mensagem="mensagemErroEmpate"
               :excecoes="listaExcecoes"
               @fechar="exibirListaErros = false"
        />

    </div>
</template>

<script>
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'
import PainelLoteEdicao from '@/views/pages/comprador/execucao-compra-direta/itens-lotes/painel-lote/PainelLoteEdicao'
import PainelItemEdicao from '@/views/pages/comprador/execucao-compra-direta/itens-lotes/painel-item/PainelItemEdicao'
import {criteriosJulgamento} from '@/core/constants'

export default {
    name: 'ItensLotesEdicao',
    components: {
        PainelLoteEdicao,
        PainelItemEdicao
    },
    data() {
        return {
            compraDiretaId: null,
            paineis: [],
            visibilidadeDialogoExclusao: false,
            idDeletar: null,
            totalmenteExpandido: false,
            mostrarDialogConfirmarSaida: false,
            rotasAvancar: [
                {
                    name: 'DocumentosEdicao'
                },
                {
                    name: 'AcompanhamentoVisualizacao'
                }
            ],
            tipo: null,
            mensagemErroEmpate: '',
            exibirListaErros: false,
            listaExcecoes: [],
        }
    },
    computed: {
        ...mapState(['itensELotes', 'parametros', 'resumoCompraDireta']),
        totalGeral() {
            let totalItens = 0
            let totalLotes = 0
            this.itensELotes.itens.forEach(item => {
                if (item.totalEstimado > 0) {
                    totalItens += item.totalEstimado
                }
            })
            this.itensELotes.lotes.forEach(lote => {
                if (lote.totalGeral > 0) {
                    totalLotes += lote.totalGeral
                }
            })
            return totalItens + totalLotes
        },
        prefix(){
            return this.resumoCompraDireta.prefixoValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.resumoCompraDireta.prefixoValor === '%' ? '%' : ''
        },
        isCriterioJulgamentoMaiorDesconto(){
            return this.resumoCompraDireta.criterioJulgamento === criteriosJulgamento.MAIOR_DESCONTO.valor
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.verificarRotaAvancar(to.name)) {
            if (!this.verificarSeVazio()) {
                next()
            } else {
                this.mostrarNotificacaoErro('É necessário que existam itens para continuar.')
            }
        } else {
            next()
        }
    },
    async mounted() {
        try {
            this.setCompraDiretaId()
            await this.buscarItensLotes()
            this.desabilitarLoadingGlobal()
            await this.buscarCompraDireta()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarCompraDireta(){
            await this.$store.dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, this.compraDiretaId)
        },
        async buscarItensLotes() {
            await this.$store.dispatch(actionTypes.BUSCAR_ITENS_E_LOTES, this.compraDiretaId)
        },
        async tratarAlteracaoExclusividadeItem(comboAlteracao) {
            await this.$store.dispatch(actionTypes.ALTERAR_EXCLUSIVIDADE_ITEM, this.gerarParametrosAlteracao(comboAlteracao))
        },
        async tratarAlteracaoExclusividadeLote(comboAlteracao) {
            await this.$store.dispatch(actionTypes.ALTERAR_EXCLUSIVIDADE_LOTE, this.gerarParametrosAlteracao(comboAlteracao))
        },
        async tratarEventoSalvar() {
            if (this.verificarSeVazio()) {
                throw new Error('Não existem itens para salvar.')
            }
            await this.salvarItensELotes()
        },
        async tratarEventoSalvarEAvancar() {
            if (this.verificarSeVazio()) {
                throw new Error('É necessário que existam itens para continuar.')
            }
            await this.salvarItensELotes()
            this.redirecionarParaProximaPagina()
        },
        async salvarItensELotesSilencioso() {
            await this.$store.dispatch(actionTypes.SALVAR_ITENS_E_LOTES, {
                compraDiretaId: this.compraDiretaId,
                itensELotes: this.itensELotes
            })
        },
        async salvarItensELotes() {
            this.habilitarLoadingGlobal()
            await this.salvarItensELotesSilencioso()
            this.desabilitarLoadingGlobal()
            this.mostrarNotificacaoSucessoDefault()
        },
        async tratarEventoExcluirConfirmado() {
            const comboObj = {
                compraDiretaId: this.compraDiretaId,
                itemId: this.idDeletar,
                loteId: this.idDeletar
            }
            if (this.tipo === 'item') {
                await this.$store.dispatch(actionTypes.REMOVER_ITEM, comboObj)
                this.mostrarNotificacaoSucesso('Item excluído com sucesso.')
            } else {
                await this.$store.dispatch(actionTypes.REMOVER_LOTE, comboObj)
                this.mostrarNotificacaoSucesso('Grupo de itens excluído com sucesso.')
            }
            this.fecharDialogo()
        },
        verificarSeVazio() {
            let estaVazio = false
            if (this.itensELotes.itens.length === 0 && this.itensELotes.lotes.length === 0) {
                estaVazio = true
            }
            return estaVazio
        },
        tratarEventoVoltar() {
            this.redirecionarParaPaginaAnterior()
        },
        redirecionarParaProximaPagina() {
            const ehSuspensa = this.resumoCompraDireta.situacao === 'SUSPENSA'
            const rotaDestino = ehSuspensa ? 'DocumentosVisualizacao' : 'DocumentosEdicao'
            this.$router.push({name: rotaDestino, params: this.compraDiretaId})
        },
        redirecionarParaPaginaAnterior() {
            this.$router.push({name: 'DadosGeraisEdicao', params: this.compraDiretaId})
        },
        verificarRotaAvancar(rotaDestino) {
            return this.rotasAvancar.some(rota => {
                return rota.name === rotaDestino
            })
        },
        exibirDialogoExclusao(itemOuLoteASerDeletado, tipo) {
            this.idDeletar = itemOuLoteASerDeletado
            this.tipo = tipo
            this.visibilidadeDialogoExclusao = true
        },
        fecharDialogo() {
            this.idDeletar = null
            this.tipo = null
            this.visibilidadeDialogoExclusao = false
        },
        gerarParametrosAlteracao(comboItemOuLoteAlterado) {
            return {
                compraDiretaId: this.compraDiretaId,
                id: comboItemOuLoteAlterado.id,
                novoValor: comboItemOuLoteAlterado.novoValor
            }
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        }
    }
}
</script>

<style scoped lang="stylus">
    .az-actions-form
        padding 0
</style>
